<template>
  <div id="components-layout-demo-basic" style="background: #ececec">
    <a-layout>
      <a-layout-header>课后服务开放平台</a-layout-header>
    </a-layout>
    <div class="page-border">
      <div class="content-card">
        <div class="group1" v-if="this.page !== 5">
          <span class="word1">{{ step[page].id }}</span>
          <span class="word2">/5</span>
        </div>
        <span class="word3">{{ step[page].message }}</span>
      </div>
      <a-card :bordered="false" class="content-card">
        <component
          :is="step[page].main"
          @nextStep="nextStep"
          @lastStep="lastStep"
        ></component>
        <!-- <RegistrationStepOne></RegistrationStepOne> -->
      </a-card>
    </div>
  </div>
</template>

<script>
import RegistrationStepOne from './RegistrationStepOne.vue'
import RegistrationStepTwo from './RegistrationStepTwo.vue'
import RegistrationStepThree from './RegistrationStepThree.vue'
import RegistrationStepFour from './RegistrationStepFour.vue'
import RegistrationStepFive from './RegistrationStepFive.vue'
import RegistrationStepSix from './RegistrationStepSix.vue'
import user from '../../../api/user'
export default {
  components: {
    RegistrationStepOne,
    RegistrationStepTwo,
    RegistrationStepThree,
    RegistrationStepFour,
    RegistrationStepFive,
    RegistrationStepSix,
  },
  data() {
    return {
      step: [
        { id: 1, message: '选择注册类型', main: RegistrationStepOne },
        { id: 2, message: '确认服务协议', main: RegistrationStepTwo },
        { id: 3, message: '确认基本信息', main: RegistrationStepThree },
        { id: 4, message: '上传资料', main: RegistrationStepFour },
        { id: 5, message: '等待审核', main: RegistrationStepFive },
        { id: 6, message: '查看申请记录', main: RegistrationStepSix },
      ],
      page: this.$store.state.register.form.page || 0,
    }
  },
  created() {
    if (this.page == 4 && this.$store.state.register.form.status == 4) {
      this.step[this.page].message = '审核已结束'
    }
    if (
      location.search.match(/type=(\d)/) &&
      location.search.match(/type=(\d)/)[1]
    ) {
      this.$store.commit(
        'register/changePersonage',
        +location.search.match(/type=(\d)/)[1]
      )
    }
  },
  watch: {
    async page() {
      if (this.page == 4) {
        await user
          .getInformation()
          .then((res) => {
            if (res.data.status == 4) {
              this.step[this.page].message = '审核已结束'
            }
          })
          .catch((e) => {
            console.log('e', e)
          })
      }
    },
  },
  methods: {
    nextStep(step) {
      this.page = this.page + step
      // console.log('this.page', this.page)
      this.$store.commit('register/changePage', this.page)
      // console.log('page', this.$store.state.register.form.page)
    },
    lastStep(step) {
      this.page = this.page - step
      this.$store.commit('register/changePage', this.page)
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1280px) {
  div.page-border {
    padding-top: 108px;
    height: 100%;
  }
}

@media screen and  (max-width: 1280px) {
  div.page-border {
    padding-top: 28px;
    padding-right: 10px;
    padding-left: 10px;
    height: 100%;
  }  
}
div.page-border {
  background: #ececec;
}
#components-layout-demo-basic {
  text-align: left;
  // height: 80px;
  // height: 100%;
  height: 100vh;
  overflow: auto;
}
#components-layout-demo-basic .ant-layout-header {
  background: #0b0b0f;
  color: #ffffff;
  font-size: 24px;
}
.content-card {
  max-width: 1080px;
  min-width: 800px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.ant-card {
  border-radius: 20px;
}
.group1 {
  z-index: 10;
  width: 43px;
  height: 40px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
  display: inline-block;
  padding-left: 30px;
}

.word1 {
  font-size: 60px;
  font-family: JCHEadA;
  color: rgba(27, 29, 38, 1);
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word2 {
  font-size: 20px;
  font-family: JCHEadA;
  color: rgba(27, 29, 38, 1);
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.word3 {
  z-index: 9;
  width: 120px;
  height: 22px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(27, 29, 38, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 22px;
  text-align: left;
  padding-left: 60px;
  margin-bottom: 20px;
}
</style>
